import React from 'react'
import { InformationCircleIcon } from '@heroicons/react/24/outline'
import type { OrderDetails } from '@/shared/api'
import { OrderStatusBadge } from './OrderStatusBadge'

const DASH = '—'

const formatText = (value: string | null | undefined): string =>
  value && value.trim() ? value : DASH

interface FieldProps {
  label: string
  children: React.ReactNode
}

const Field: React.FC<FieldProps> = ({ label, children }) => (
  <div>
    <dt className="text-xs font-medium uppercase tracking-wide text-gray-500">
      {label}
    </dt>
    <dd className="mt-1 break-words text-sm text-gray-900">{children}</dd>
  </div>
)

export interface OrderDeliveryTabProps {
  order: OrderDetails
}

/**
 * Вкладка «Доставка». Данные только читаются: изменений здесь нет.
 */
export const OrderDeliveryTab: React.FC<OrderDeliveryTabProps> = ({ order }) => (
  <div className="space-y-4">
    <section className="rounded-lg border border-gray-200 p-4">
      <h3 className="text-sm font-semibold text-gray-900">Доставка</h3>
      <dl className="mt-3 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <Field label="Дата доставки">
          {formatText(order.deliveryDateFormatted)}
        </Field>
        <Field label="Интервал доставки">
          {formatText(order.deliveryInterval?.label)}
        </Field>
        <Field label="Локальный статус">
          <OrderStatusBadge
            status={order.status}
            statusText={order.statusText}
          />
        </Field>
        <Field label="Статус в R-CRM">
          {formatText(order.externalStatusName || order.externalStatus)}
        </Field>
        <Field label="Тип доставки">
          {formatText(order.deliveryTypeName || order.deliveryType)}
        </Field>
      </dl>
    </section>

    <div className="flex items-start gap-2 rounded-lg border border-gray-200 bg-gray-50 p-3">
      <InformationCircleIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-gray-400" />
      <p className="text-sm text-gray-500">
        Изменение появится в следующем срезе
      </p>
    </div>
  </div>
)
